(function initJrnlVariantViewDispatcher() {
  if (window.JRNL && window.JRNL.fireVariantView) return;

  var STORE_PREFIX = 'shopify_ZZ';
  var lastVariantIdSent = null;

  function centsToNumber(cents){ return Math.round(cents || 0) / 100; }
  function dollarsToCents(x){
    if (x == null) return 0;
    if (typeof x === 'number') return Math.round(x * 100);
    var f = parseFloat(String(x).replace(/[^0-9.]/g,''));
    return Number.isFinite(f) ? Math.round(f * 100) : 0;
  }

  function getCurrencyFallback(){
    try { if (window.Shopify?.currency?.active) return Shopify.currency.active; } catch(e){}
    return "{{ shop.currency | default: 'USD' }}";
  }

  function normalizeProduct(p){
    return {
      id: Number(p.id),
      title: p.title || p.product_title || '',
      vendor: p.vendor || '',
      type: p.type || p.product_type || ''
    };
  }

  function normalizeVariant(v){
    // accept cents number, or dollars number/string
    var cents = 0;
    if (typeof v?.price === 'number' && v.price > 10) { 
      cents = Math.round(v.price);
    } else if (v?.price_cents != null) {
      cents = Math.round(Number(v.price_cents) || 0);
    } else if (v?.price != null) {
      cents = dollarsToCents(v.price);
    }
    return {
      id: Number(v.id),
      title: v.name || v.title || '',
      price_cents: cents,
      sku: v.sku || ''
    };
  }

  function buildPayload(prod, varnt){
    return {
      productId: prod.id,
      variantId: varnt.id,
      item_id: STORE_PREFIX + '_' + prod.id + '_' + varnt.id, // must match feed
      title: prod.title,
      vendor: prod.vendor,
      type: prod.type,
      variant_title: varnt.title,
      price_cents: varnt.price_cents,
      currency: getCurrencyFallback(),
      sku: varnt.sku
    };
  }
  function buildPayload2(prod, varnt){
    return {
      productId: prod.id,
      variantId: varnt.id,
      item_id: prod.id, 
      title: prod.title,
      vendor: prod.vendor,
      type: prod.type,
      variant_title: varnt.title,
      price_cents: varnt.price_cents,
      currency: getCurrencyFallback(),
      sku: varnt.sku
    };
  }

  // --- GA4 sender (page context) ---
  function gtagViewItem(data){
    try {
      if (!window.gtag) return false;
      var priceDollars = centsToNumber(data.price_cents);

      window.gtag('event', 'view_item', {
        currency: data.currency,
        value: priceDollars,
        items: [{
          item_id: data.item_id,
          item_name: data.title,
          item_brand: data.vendor || '',
          item_category: data.type || '',
          item_variant: data.variant_title,
          price: priceDollars,
          quantity: 1
        }],
        event_source: 'variant_selected',

        // Google Ads remarketing extras
        ecomm_pagetype: window.JRNL?.ecommPageType || 'product',
        ecomm_prodid: [ data.item_id ],
        ecomm_totalvalue: priceDollars
      });
    } catch(e){}
  }
  function dlViewItem(data){
    try {
      var priceDollars = centsToNumber(data.price_cents);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event : 'view_item_stape', ecommerce : {
        currency: data.currency,
        value: priceDollars,
        items: [{
          item_id: data.item_id,
          item_name: data.title,
          item_brand: data.vendor || '',
          item_category: data.type || '',
          item_variant: data.variantId,
          variant_name: data.variant_title,
          item_sku: data.sku,
          price: priceDollars,
          quantity: 1
        }],
        event_source: 'variant_selected',

        // Google Ads remarketing extras
        ecomm_pagetype: window.JRNL?.ecommPageType || 'product',
        ecomm_prodid: [ data.item_id ],
        ecomm_totalvalue: priceDollars
      }});
    } catch(e){}
  }

  window.JRNL = window.JRNL || {};
  // How long the shopper must settle on a variant before we report a view_item.
  var VIEW_DEBOUNCE_MS = 500;

  // Run the GA4/GTM push when the main thread is idle, so the (heavy) GTM tag evaluation
  // never competes with the paint that follows a variant tap — this is what protects INP.
  // Falls back to a macrotask where requestIdleCallback is unavailable (older Safari).
  function onIdle(fn){
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn, { timeout: 2000 });
    else setTimeout(fn, 0);
  }

  function sendVariantView(prod, varnt){
    if (Number(varnt.id) === Number(lastVariantIdSent)) return; // already reported
    lastVariantIdSent = varnt.id;
    var payload = buildPayload(prod, varnt);
    if (!gtagViewItem(payload)) {
      dlViewItem(buildPayload2(prod, varnt));
    }
  }

  var viewDebounceTimer = null;
  var viewPending = null;

  window.JRNL.fireVariantView = function(product, variant, opts){
    opts = opts || {};
    if (!product || !variant) return;

    var prod  = normalizeProduct(product);
    var varnt = normalizeVariant(variant);

    // Already reported this exact variant — nothing to do.
    if (!opts.force && Number(varnt.id) === Number(lastVariantIdSent)) return;

    viewPending = { prod: prod, varnt: varnt };

    // force -> report right away (still scheduled off the interaction, via idle).
    if (opts.force) {
      if (viewDebounceTimer) { clearTimeout(viewDebounceTimer); viewDebounceTimer = null; }
      var pf = viewPending; viewPending = null;
      onIdle(function(){ sendVariantView(pf.prod, pf.varnt); });
      return;
    }

    // Debounce: report only the variant the shopper settles on, instead of firing a GA4
    // view_item + full GTM tag evaluation on every intermediate swatch / band / cup / size tap.
    if (viewDebounceTimer) clearTimeout(viewDebounceTimer);
    viewDebounceTimer = setTimeout(function(){
      viewDebounceTimer = null;
      var p = viewPending; viewPending = null;
      if (p) onIdle(function(){ sendVariantView(p.prod, p.varnt); });
    }, VIEW_DEBOUNCE_MS);
  };
  window.JRNL.ecommPageType = (function(path){
    if (/\/products\//.test(path))    return 'product';
    if (/\/collections\//.test(path)) return 'category';
    if (/\/search/.test(path))        return 'searchresults';
    if (/\/cart/.test(path))          return 'cart';
    return 'other';
  })(location.pathname);
})();